import React, { SVGProps } from 'react'

export function AnemiaInSight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 13C17.4367 13 19 11.4048 19 9.42857C19 7.04762 15.5 3 15.5 3C15.5 3 12 7.04762 12 9.42857C12 11.4048 13.5633 13 15.5 13ZM15.5 6.94048C16.1883 8.02381 16.6667 9 16.6667 9.42857C16.6667 10.0833 16.1417 10.619 15.5 10.619C14.8583 10.619 14.3333 10.0833 14.3333 9.42857C14.3333 8.9881 14.8117 8.0119 15.5 6.94048ZM18.4286 15H21V21H18.4286V15ZM15.8571 17H13.2857V21H15.8571V17ZM8.14286 15H10.7143V21H8.14286V15ZM5.57143 6H3V21H5.57143V6Z"
      />
    </svg>
  )
}
